import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/ui/routes';
// Connects the domain's injected dependencies (AI, Drive, media) to their real
// implementations before the first render. Side-effect import; see wiring.ts.
import './wiring';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
